import React from 'react';
import {withSystem, Atom} from '@packages/systems/wfdl';
import {TRecord, TText, TListOfElement} from '@packages/systems/wfdl-ast';
import {USYS_DATA_ATTRS} from '@packages/systems/users/constants';
import {UsysUtilityPageConstraint} from '../utils';
import {createIntegratedAtom} from '@packages/utilities/integrated-types';
import {getChildren} from '@packages/utilities/data-utils';

const UserSignUpRedirectWrapper = Atom.createRender(
  ({data, generateAttributes, attributes, classes, renderChild}) => (
    <div {...generateAttributes(attributes, classes)}>
      {getChildren(data).map((child) => renderChild(child))}
    </div>
  )
);

const config = createIntegratedAtom({
  displayName: 'Redirect Block',
  constraints: {
    ancestors: [{is: 'UserFormSuccessState', rule: 'ExactlyOne'}],
    descendants: [{is: 'Link', rule: 'ExactlyOne'}],
    page: [UsysUtilityPageConstraint],
  },
  showEmpty: true,
  render: UserSignUpRedirectWrapper,
  fields: {
    children: TListOfElement,
    attr: TRecord({
      [USYS_DATA_ATTRS.redirectUrl]: withSystem({private: true}, TText),
    }),
  },
  hideAncestorSettings: true,
});

export default config;
